package hk.com.vr360_demo2.webapp.component.viewer

import cc.easyandroid.easycompose.mvi.store.Bootstrapper
import cc.easyandroid.easycompose.mvi.store.Executor
import cc.easyandroid.easycompose.mvi.store.Reducer
import cc.easyandroid.easycompose.mvi.store.StoreFactory
import cc.easyandroid.extensions_compose.mvi.coroutineBootstrapper
import cc.easyandroid.extensions_compose.mvi.coroutineExecutorFactory
import cc.easyandroid.extensions_compose.mvi.createReducer
import hk.com.vr360_demo2.webapp.core.mvi.EasyStoreViewModel
import hk.com.vr360_demo2.webapp.core.mvi.EffectEither
import hk.com.vr360_demo2.webapp.core.net.KtorPublicApi
import hk.com.vr360_demo2.webapp.core.net.fold
import hk.com.vr360_demo2.webapp.core.ui_state.NetworkState
import kotlinx.coroutines.launch

class ViewerViewModel(
    private val id: String,
    private val uid: String?,
    private val token: String?,
    private val publicApi: KtorPublicApi,
    restoredActiveSceneIndex: Int?,
    storeFactory: StoreFactory,
) : EasyStoreViewModel<ViewerIntent, ViewerAction, ViewerState, ViewerMessage, ViewerEffect>(storeFactory) {

    override val initialState: ViewerState = ViewerState(
        activeSceneIndex = restoredActiveSceneIndex ?: 0,
    )

    override fun onCreateBootstrapper(): Bootstrapper<ViewerAction> = coroutineBootstrapper {
        dispatch(ViewerAction.InitialLoad)
    }

    override fun onCreatExecutor(): () -> Executor<ViewerIntent, ViewerAction, ViewerState, ViewerMessage, EffectEither<ViewerEffect>> {
        return coroutineExecutorFactory {
            onIntent<ViewerIntent.Refresh> {
                forward(ViewerAction.InitialLoad)
            }

            onIntent<ViewerIntent.SwitchScene> { intent ->
                val scenesSize = state().scenes.size
                if (scenesSize == 0) return@onIntent
                val nextIndex = intent.sceneIndex.coerceIn(0, scenesSize - 1)
                dispatch(ViewerMessage.SceneSwitched(nextIndex))
            }

            onAction<ViewerAction.InitialLoad> {
                dispatch(ViewerMessage.Loading)
                launch {
                    publicApi.loadVr360ViewData(
                        id = id,
                        uid = uid,
                        token = token,
                    ).fold(
                        onError = { error ->
                            dispatch(ViewerMessage.LoadFailure(error.message ?: "加載失敗"))
                        },
                        onSuccess = { response ->
                            val panoramaData = response.data
                            val scenes = panoramaData.toViewerScenes()
                            dispatch(ViewerMessage.LoadSuccess(panoramaData, scenes))
                        },
                    )
                }
            }
        }
    }

    override fun onCreateReducer(): Reducer<ViewerState, ViewerMessage> {
        return createReducer {
            onMessage<ViewerMessage.Loading> {
                state.copy(
                    isLoading = true,
                    networkState = NetworkState.Good,
                )
            }

            onMessage<ViewerMessage.LoadSuccess> { message ->
                val nextActiveIndex = if (message.scenes.isEmpty()) {
                    0
                } else {
                    state.activeSceneIndex.coerceIn(0, message.scenes.lastIndex)
                }
                state.copy(
                    isLoading = false,
                    panoramaData = message.panoramaData,
                    scenes = message.scenes,
                    activeSceneIndex = nextActiveIndex,
                    networkState = NetworkState.Good,
                )
            }

            onMessage<ViewerMessage.LoadFailure> { message ->
                state.copy(
                    isLoading = false,
                    panoramaData = null,
                    scenes = emptyList(),
                    activeSceneIndex = 0,
                    networkState = NetworkState.Failed(
                        message = message.message.takeIf { it.isNotBlank() } ?: "加載失敗",
                    ),
                )
            }

            onMessage<ViewerMessage.SceneSwitched> { message ->
                state.copy(activeSceneIndex = message.sceneIndex)
            }
        }
    }
}
